import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { convertAutocompleteItemToApi } from "@monorepo/utils/src/api/convertFiltersToApi";
import { fields } from "@monorepo/utils/src/variables/projectsData/passportArchiveStoreReport/fields";

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject & { fieldFilters: { date?: string } }): void => {
  convertAutocompleteItemToApi(resultFilters, fields.FILTER_ARCHIVE, `fieldFilters.${fields.FILTER_ARCHIVE}.name`);
};
